var map = {
	"./addliquidity.json": 1048,
	"./box.json": 1049,
	"./components.json": 1050,
	"./constants.json": 1051,
	"./error.json": 1052,
	"./farm.json": 1053,
	"./home.json": 1054,
	"./launchpad.json": 1055,
	"./menu.json": 1056,
	"./minning.json": 1057,
	"./nft.json": 1058,
	"./pool.json": 1059,
	"./referral.json": 1060,
	"./removeliquidity.json": 1061,
	"./rolling.json": 1062,
	"./swap.json": 1063,
	"./team.json": 1064,
	"./uikit.json": 1065
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1047;